import {RateRuleType} from './rate-rule.type.model';
export class RateRule {
  type: RateRuleType;
  description: string;
  value: any;
  constructor(type: RateRuleType, description?: string, value?: any) {
    this.type = type;
    this.description = description;
    this.value = value;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/rate-rule.model.ts